import React, { useState, useCallback } from 'react';
import Header from './Header';
import AboutSection from './About';
import HowToUseSection from './HowToUse';
import MapSection from './Map';
import ResultsList from './ResultList';

const GroceryStoresPage = () => {
  //const [selectedItem, setSelectedItem] = useState(null);
  //console.log(selectedItem)
  const [itemResults, setItemResults] = useState(null);
  const [itemSelected, selectItem] = useState(false);
  const [storeIdToFocus, setStoreIdToFocus] = useState(null);

  const handleStoreFocusHandled = useCallback(() => {
    setStoreIdToFocus(null);
  }, []);

  return (
    <main>
      <Header />
      <AboutSection />
      <HowToUseSection />
      <MapSection
        setItemResults={setItemResults}
        selectItem={selectItem}
        storeIdToFocus={storeIdToFocus}
        onStoreFocusHandled={handleStoreFocusHandled}
      />
      {itemSelected && itemResults && (
        <ResultsList
          itemResults={itemResults}
          onStoreCardClick={setStoreIdToFocus}
        />
      )}
    </main>
  );
};

export default GroceryStoresPage;

